import axios from "../../axios";
import AxiosWeb from "../../axios";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const dashboardlist = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'dashboardlist',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const sendOtp = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'credit-decision/otp-send',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const verifyOtp = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'credit-decision/otp-verify',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const resendOtp = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'credit-decision/otp-resend',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const verifyPan = async (data, encrypt = false) => {
  const response = await AxiosWeb.post(API_BASE_URL + 'credit-decision/pan-verify', data, {
    encrypt: encrypt // This tells axios interceptor to encrypt
  });
  return response?.data;
}

const createApplication = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'credit-decision/create-application',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const fetchData = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'credit-decision/fetch-data',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const fetchAllDetails = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'credit-decision/fetch-all-details',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const getApplicationData = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'common/get-status',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const fetchNotification = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'common/notification',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const dashboardService = {
  dashboardlist,
  sendOtp,
  verifyOtp,
  resendOtp,
  verifyPan,
  createApplication,
  fetchData,
  fetchAllDetails,
  getApplicationData,
  fetchNotification
};

export default dashboardService;
